import React, { useCallback, useMemo } from 'react';
import { FaGlobe, FaPencilRuler, FaStar, FaRocket, FaBlog, FaBook } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Style from '../assets/css/functions.module.css';

const Functions = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const scrollToBottom = useCallback(() => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth',
        });
    }, []);

    const examples = useMemo(() => [
        {
            title: t('data_planet'),
            description: t('exo_planet'),
            icon: <FaGlobe className={Style.icon} />,
            action: scrollToBottom,
        },
        {
            title: t('constellation'),
            description: t('draw_constellation'),
            icon: <FaPencilRuler className={Style.icon} />,
            action: () => navigate('/draw2D'),
        },
        {
            title: 'Stargram',
            description: t('stargram_desc'),
            icon: <FaBook className={Style.icon} />,
            action: () => navigate('/drawings'),
        },
        {
            title: 'Stellarium',
            description: t('stellarium_desc'),
            icon: <FaStar className={Style.icon} />,
            action: () => navigate('/stellarium'),
        },
        // {
        //     title: t('nasa'),
        //     description: t('nasa_desc'),
        //     icon: <FaRocket className={Style.icon} />,
        //     action: () => navigate('/picture'),
        // },
        {
            title: 'Blog',
            description: t('blog_desc'),
            icon: <FaBlog className={Style.icon} />,
            action: () => navigate('/blog'),
        },
    ], [t, navigate, scrollToBottom]);

    const handleCardClick = useCallback((action) => {
        return (e) => {
            if (e.key && e.key !== 'Enter' && e.key !== ' ') return;
            action();
        };
    }, []);

    return (
        <section className={Style.functionsContainer}>
            <h1 className={Style.title}>{t('functions')}</h1>
            <div className={Style.cardGrid}>
                {examples.map((example, index) => (
                    <div
                        key={`function-${index}`}
                        className={Style.card}
                        onClick={handleCardClick(example.action)}
                        onKeyDown={handleCardClick(example.action)}
                        role="button"
                        tabIndex={0}
                        aria-label={`${example.title}. ${example.description}`}
                    >
                        <div className={Style.iconContainer}>{example.icon}</div>
                        <h2 className={Style.cardTitle}>{example.title}</h2>
                        <p className={Style.cardDescription}>{example.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default React.memo(Functions);
